export default __webpack_public_path__ + "static/media/54.4cf67ad8.jpg";